import { colors, typography } from '../styles/theme';

/** Tokens visuales del tour — mismos paneles que FilterPanel, search y banners. */
export const TOUR_THEME = {
  accent: colors.primary,
  accentHover: colors.primaryHover,
  accentSoft: 'rgba(72, 146, 145, 0.22)',
  panelBg: colors.backgroundSurface,
  /** Opaco, para la flecha SVG de Joyride. */
  panelBgSolid: colors.backgroundSurface,
  panelBorder: colors.border,
  panelShadow: '0 8px 32px rgba(0, 0, 0, 0.55)',
  textPrimary: colors.textPanelDescription,
  textSecondary: colors.textPrimary,
  textMuted: colors.textSecondary,
  textCaption: colors.textSecondary,
  overlay: 'rgba(0, 0, 0, 0.58)',
  fontFamily: typography.fontFamily.primary,
  borderRadius: 12,
  tooltipMaxWidth: 288,
};
